export default "__VITE_ASSET__CsVnoLmW__"